export default "__VITE_ASSET__Rd2BD_lw__"